/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Problem_DismissInputs */

const en_problem_dismiss = /** @type {(inputs: Problem_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`I don't have this problem`)
};

const de_problem_dismiss = /** @type {(inputs: Problem_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Betrifft mich nicht`)
};

const zh_tw_problem_dismiss = /** @type {(inputs: Problem_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我沒有這個需求`)
};

const zh_cn_problem_dismiss = /** @type {(inputs: Problem_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`我没有这个需求`)
};

const es_problem_dismiss = /** @type {(inputs: Problem_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tengo ese problema`)
};

const fr_problem_dismiss = /** @type {(inputs: Problem_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Je n'ai pas ce problème`)
};

const it_problem_dismiss = /** @type {(inputs: Problem_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Non ho questo problema`)
};

const pt_br_problem_dismiss = /** @type {(inputs: Problem_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Não preciso disso`)
};

const ja_problem_dismiss = /** @type {(inputs: Problem_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`私には必要ないかな`)
};

const ko_problem_dismiss = /** @type {(inputs: Problem_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`저는 해당 안 돼요`)
};

const ru_problem_dismiss = /** @type {(inputs: Problem_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`У меня нет такой проблемы`)
};

const th_problem_dismiss = /** @type {(inputs: Problem_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ฉันไม่มีปัญหานี้`)
};

const tr_problem_dismiss = /** @type {(inputs: Problem_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Böyle bir ihtiyacım yok`)
};

const ar_problem_dismiss = /** @type {(inputs: Problem_DismissInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لا أحتاج هذا`)
};

/**
* | output |
* | --- |
* | "I don't have this problem" |
*
* @param {Problem_DismissInputs} inputs
* @param {{ locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }} options
* @returns {LocalizedString}
*/
export const problem_dismiss = /** @type {((inputs?: Problem_DismissInputs, options?: { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Problem_DismissInputs, { locale?: "en" | "de" | "zh_tw" | "zh_cn" | "es" | "fr" | "it" | "pt_br" | "ja" | "ko" | "ru" | "th" | "tr" | "ar" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_problem_dismiss(inputs)
	if (locale === "de") return de_problem_dismiss(inputs)
	if (locale === "zh_tw") return zh_tw_problem_dismiss(inputs)
	if (locale === "zh_cn") return zh_cn_problem_dismiss(inputs)
	if (locale === "es") return es_problem_dismiss(inputs)
	if (locale === "fr") return fr_problem_dismiss(inputs)
	if (locale === "it") return it_problem_dismiss(inputs)
	if (locale === "pt_br") return pt_br_problem_dismiss(inputs)
	if (locale === "ja") return ja_problem_dismiss(inputs)
	if (locale === "ko") return ko_problem_dismiss(inputs)
	if (locale === "ru") return ru_problem_dismiss(inputs)
	if (locale === "th") return th_problem_dismiss(inputs)
	if (locale === "tr") return tr_problem_dismiss(inputs)
	return ar_problem_dismiss(inputs)
});